import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';
import UserCurrencyStore from './user_currency_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  runRecipe,
};

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function runRecipe(params, done = null) {
  const { idempotent_key, recipe_id, item_client_data } = params;
  if (UserStore.isLoggedIn()) {
    const opts = {
      url: `/client/1/recipe/${recipe_id}`,
      body: {
        idempotent_key,
        item_client_data,
      },
    };
    UserStore.post(opts, (err, body) => {
      if (err) {
        if (body && body.recipe_limit) {
          err = 'limit';
        } else {
          util.errorLog('ItemStore.runRecipe: err:', err);
        }
      } else if (body) {
        const { consume_list } = body;
        UserCurrencyStore.debitList(consume_list);
      }
      done(err);
    });
  } else {
    done('not_logged_in');
  }
}
